import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import blog1Styles from './Blog1Styles';
import Navbar from "../../../../components/Navbar/Navbar";
import Footer from "../../../../components/Footer/Footer";
import CTA from "../../../../components/CTA/CTA";

type Blog1Props = {

};

const StyledBlog1 = styled('section')(({ theme }) => blog1Styles);

const Blog1: React.FC<Blog1Props> = () => (
  <Fragment>
    <Navbar fixedScrolled/>
    <StyledBlog1 className="pt-8 lg:py-0">
      <main className="pt-0 lg:pt-[8rem] antialiased">
        <div id="blog-container" className="py-16 rounded-lg flex justify-between px-8 mx-auto max-w-screen-xl ">
          <article className="mx-auto w-full max-w-4xl format format-sm sm:format-base lg:format-lg format-blue">
            <header className="mb-4 lg:mb-6 not-format">
              <address className="flex items-center mb-6 not-italic">
                <div className="inline-flex items-center mr-3 text-sm text-gray-900">
                  <img loading="lazy" className="mr-4 w-16 h-16 rounded-full" src="https://grupogm-assets.s3.us-east-1.amazonaws.com/blog-avatar-mariana.jpg" alt="Mariana Osorio" />
                  <div>
                    <a href="#" rel="author" className="text-xl font-bold text-gray-900">Mariana Osorio</a>
                    <p className="text-base text-gray-500">Coordinadora Administrativa</p>
                    <p className="text-base text-gray-500"><time title="Oct 12, 2025">Oct 12, 2025</time></p>
                  </div>
                </div>
              </address>
              <h1 className="text-3xl font-extrabold leading-tight text-gray-900 lg:text-4xl">Cómo ahorrar costos logísticos rentando cajas secas en lugar de comprarlas</h1>
                <p>
                  Muchas empresas buscan reducir costos sin afectar la operación. En 2025, rentar
                  cajas secas es una estrategia clave para aumentar flexibilidad y mejorar flujo
                  de efectivo.
                  </p>
                                  </header>


                                  <section>
                  <h2>Comparativa financiera: renta vs compra</h2>
                  <p>
                  Comprar una caja seca implica una alta inversión inicial y gastos constantes
                  en mantenimiento. En cambio, rentar ofrece ventajas como:
                  </p>
                  <ul>
                  <li>Eliminación del gasto inicial de adquisición.</li>
                  <li>Costos variables que se ajustan a temporadas de alta o baja demanda.</li>
                  <li>Evitar depreciación y pérdida de valor del equipo.</li>
                  <li>No pagar almacenamiento ni trámites adicionales.</li>
                  </ul>
                  </section>


                  <section>
                  <h2>Flexibilidad operativa y reducción de riesgos</h2>
                  <p>
                  La renta permite activar o desactivar equipos según necesidades reales. Esto es
                  especialmente útil para empresas con variaciones en carga o proyectos temporales.
                  </p>
                  <ul>
                  <li>Acceso a modelos más recientes y mejor equipados.</li>
                  <li>Menor exposición a fallas inesperadas.</li>
                  <li>Capacidad de ajustar rápidamente la flota.</li>
                  </ul>
                  </section>


                                  <section>
                  <h2>Ventajas fiscales en México</h2>
                  <p>
                  Para contribuyentes RESICO y personas morales, la renta puede representar un
                  beneficio fiscal, ya que se deduce como gasto operativo. Esto mejora la liquidez
                  y simplifica la contabilidad.
                  </p>
                  </section>


                  <section>
                  <h2>Cuándo sí conviene comprar</h2>
                  <p>
                  En operaciones con uso constante de equipo (más del 85%), comprar podría resultar
                  más rentable a largo plazo. Sin embargo, requiere capital disponible y capacidad
                  de mantenimiento.
                  </p>
                  </section>


                                  <section>
                  <h2>Recomendaciones para maximizar el ahorro</h2>
                  <ul>
                  <li>Negocia contratos flexibles por volumen o tiempo de uso.</li>
                  <li>Evalúa periódicamente costos logísticos y rotación de equipo.</li>
                  <li>Evita operar cajas en mal estado que aumenten consumo de combustible.</li>
                  <li>Centraliza tu operación para reducir recorridos sin carga.</li>
                  </ul>
                  </section>


                  <footer>
                  <p>
                  En Grupo GM contamos con cajas secas de 48 y 53 pies listas para rentarse
                  según tus necesidades operativas.
                  </p>
                  </footer>
                </article>
        </div>
      </main>
    
    <CTA
      title="Envíanos tu carga y solicita asesoría gratis"
      description="Envíanos tu carga y solicita asesoría gratis"
      buttonText="Llámanos"
    />
    <aside id="blog-related-articles" aria-label="Related articles" className="flex pt-8 pb-16 lg:py-24 bg-gray-50">
      <div className="px-4 mx-auto max-w-screen-xl">
        <h2 className="mb-8 text-2xl font-bold text-gray-900">Artículos relacionados</h2>
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <article className="max-w-xs">
            <a href="#">
              <img loading="lazy" src="https://i.natgeofe.com/n/6c02ad5a-977b-4f12-b9c0-02ffb0736e07/metropolitan-cathedral-zocalo-mexico-city.JPG" className="mb-5 w-full rounded-lg" alt="Requisitos y mejores prácticas para transportar carga en México en 2025" />
            </a>
            <h2 className="mb-2 mt-2 text-xl font-bold leading-tight text-gray-900">
              <a href="#">Requisitos y mejores prácticas para transportar carga en México en 2025</a>
            </h2>
            <p className="mb-4 text-gray-500">En este artículo te explicamos los errores más frecuentes y cómo evitarlos para asegurar que tu operación sea rápida, segura y rentable.</p>
            <a href="#" className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 hover:no-underline">
              Lea en 5 minutos
            </a>
          </article>
          <article className="max-w-xs">
            <a href="#">
              <img loading="lazy" src="https://wp.tyt.com.mx/wp-content/uploads/2025/05/tractocamion-sobrecarga-1024x597.jpg" className="mb-5 w-full rounded-lg" alt="Guía completa para elegir la caja seca ideal según tu tipo de carga" />
            </a>
            <h2 className="mb-2 mt-2 text-xl font-bold leading-tight text-gray-900">
              <a href="#">Guía completa para elegir la caja seca ideal según tu tipo de carga</a>
            </h2>
            <p className="mb-4 text-gray-500">En esta guía te explicamos las diferencias entre cajas secas de 48 y 53 pies, cuándo conviene usar una plataforma o una cama baja, y qué factores debes considerar antes de rentar.</p>
            <a href="#" className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 hover:no-underline">
              Read in 2 minutes
            </a>
          </article>
          <article className="max-w-xs">
            <a href="#">
              <img loading="lazy" src="https://www.poderyfinanzas.com/wp-content/uploads/2023/03/pexels-quintin-gellar-2199293-scaled.jpg" className="mb-5 w-full rounded-lg" alt="Errores comunes al rentar una caja seca y cómo evitarlos" />
            </a>
            <h2 className="mb-2 mt-2 text-xl font-bold leading-tight text-gray-900">
              <a href="#">Errores comunes al rentar una caja seca y cómo evitarlos</a>
            </h2>
            <p className="mb-4  text-gray-500">En este artículo platicamos sobre los errores comunes al rentar una caja seca y cómo evitarlos.</p>
            <a href="#" className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 hover:no-underline">
              Lea en 4 minutos
            </a>
          </article>
          <article className="max-w-xs">
            <a href="#">
              <img loading="lazy" src="https://a.travel-assets.com/findyours-php/viewfinder/images/res70/225000/225737-Monumental-Clock-Of-Pachuca.jpg?impolicy=fcrop&w=400&h=225&q=mediumLow" className="mb-5 w-full rounded-lg" alt="Zonas estratégicas de operación en Hidalgo y centro del país: ventajas logísticas y rutas clave" />
            </a>
            <h2 className="mb-2 mt-2 text-xl font-bold leading-tight text-gray-900">
              <a href="#">Zonas estratégicas de operación en Hidalgo y centro del país: ventajas logísticas y rutas clave</a>
            </h2>
            <p className="mb-4  text-gray-500">En este artículo hacemos un recorrido de las zonas estratégicas de operación en Hidalgo y centro del país.</p>
            <a href="#" className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 hover:no-underline">
              Lea en 8 minutos
            </a>
          </article>
        </div>
      </div>
    </aside>
    </StyledBlog1>
    <Footer />
  </Fragment>
);

export default Blog1;